var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_wrapper"},[_c('carousel-section'),_vm._v(" "),_c('news-section',{attrs:{"pieces-news":_vm.latestNews}}),_vm._v(" "),_c('jobs-section'),_vm._v(" "),_c('links-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }